var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewGaurdian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.356 31.111a14.82 14.82 0 0 1 15.73-3.01 58.3 58.3 0 0 0-.69-20.39 2.533 2.533 0 0 0-3.03-1.88 27.68 27.68 0 0 1-18.1-2.04 2.42 2.42 0 0 0-2.19 0 30 30 0 0 1-5.78 2.04 27.9 27.9 0 0 1-12.34 0 2.517 2.517 0 0 0-3.01 1.88c-4.44 21.71 2.45 43.09 22.22 48.11a29.5 29.5 0 0 0 6.06-2.24 23.75 23.75 0 0 1-3.47-11.75 14.67 14.67 0 0 1 4.6-10.72",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.396 34.151c-6.978-8.358-20.702-3.085-20.64 7.68 0 7.39 5.2 13.91 8.3 17.15a4.91 4.91 0 0 0 7.04-.02 37 37 0 0 0 4.79-6.17c3.518-5.35 5.231-13.345.51-18.64m-8.83 13.69a6.2 6.2 0 0 1-6.19-6.19c.295-8.191 12.087-8.19 12.38 0a6.2 6.2 0 0 1-6.19 6.19",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.566 38.461a3.19 3.19 0 0 0 0 6.38 3.19 3.19 0 0 0 0-6.38",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGaurdian);
export default __webpack_public_path__ + "static/media/new-gaurdian.fddd22dd4c9969df88185b4690105ab4.svg";
export { ForwardRef as ReactComponent };